/* eslint-disable */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@entrata/portals-common/lib/components/forms';
import { ZipField } from '@entrata/portals-common/lib/standard-fields';
import { Btn } from 'components/buttons';
import { navigate } from 'gatsby';
import { connect } from 'react-redux';
import { requestProperties } from 'redux/modules/properties';
import { setZip, setStateAtStep, setActiveStep, setLeadSourceType } from 'redux/modules/getQuote';
import styled from '@emotion/styled';
import insuranceCarrierTypes from 'constants/insuranceCarrierTypes';
import { RED } from 'constants/theme';
import queryString from 'query-string';
import {
  sync,
  events,
  properties as digitalAnalyticsProperties,
  CHANNEL_NAME,
  CONTROL_VARIANT,
  useVariant,
} from 'api/digitalAnalytics';

const StyledForm = styled(Form)`
  max-width: 100%;

  input {
    height: 48px;
    border-radius: 8px;
  }

  @media only screen and (min-width: 768px) {
    display: flex;
    flex-direction: ${(props) => (!!props.blockedDisplay ? 'column' : 'row')};

    div {
      margin-right: ${(props) => !props.blockedDisplay && '8px'};
    }
  }
`;

const StyledZipField = styled(ZipField)`
  margin: 0 auto;
  input {
    font-family: ${({ theme }) => theme.fonts.light};
    color: ${({ theme }) => theme.gray.base};
    font-size: 16px;
    border: 1px solid #d0d2d3;
  }
`;

const StyledBtn = styled(Btn)`
  ${(props) => {
    if (!!props.blockedDisplay) {
      return {
        display: 'block',
        margin: '18px auto 0',
      };
    }
  }}

  @media only screen and (max-width: 767px) {
    font-size: 16px;
    padding: 0 28px;
  }
`;
const StyledErrorMsg = styled('p')`
  display: ${(props) => (props.toggleErrorMsg ? 'none' : 'block')};
  color: ${RED};
  font-weight: bold;
  font-size: 16px;
  text-align: center;
`;

class CtaForm extends Component {
  state = {
    toggleErrorMsg: this.props.currentStepError == '',
  };

  componentDidMount() {
    const { location, setLeadSourceType } = this.props;
    const params = queryString.parse(location?.search);

    if (params.source) sessionStorage.setItem('leadSourceTypeId', params.source);
    const leadSourceTypeId = sessionStorage.getItem('leadSourceTypeId');
    if (leadSourceTypeId) setLeadSourceType({ value: leadSourceTypeId });

    if (params.zip) {
      this.setZipAndRouteToQuote(params.zip, params.source);
    }
  }

  componentDidUpdate(prevProps) {
    const { currentStepError, setStateAtStep, setActiveStep } = this.props;
    if (currentStepError !== prevProps.currentStepError) {
      this.setState(
        (prevState) => ({
          toggleErrorMsg: !prevState.toggleErrorMsg,
        }),
        () => {
          !this.state.toggleErrorMsg &&
            (setStateAtStep({ step: 0, complete: false }), setActiveStep({ activeStep: 0 }));
        },
      );
    }
  }
  routeToQuote = ({ fields: { zip } }) => {
    const { property, properties, isAgent } = this.props;
    const params = queryString.parse(location?.search);

    let selectedProperty = properties[property];

    if (
      isAgent &&
      Object.keys(selectedProperty).length &&
      ![insuranceCarrierTypes.MARKEL, insuranceCarrierTypes.MSI].includes(selectedProperty?.carrierId)
    ) {
      window.location.href = selectedProperty.redirectUrl;
    } else {
      this.setZipAndRouteToQuote(zip.value || this.props.zip);
    }
  };

  setZipAndRouteToQuote = (zip, source) => {
    const { productId, requestProperties, setStateAtStep, setZip, leadSourceType, quoteVersion } = this.props;
    const { LEAD_SOURCE, CHANNEL, QUOTE_VERSION } = digitalAnalyticsProperties;
    const { QUOTE_STARTED } = events;

    setZip({ value: zip });
    requestProperties({
      zip,
      productId,
      delay: 3000,
      onRequestFail: () => {
        navigate(`/get-quote-${quoteVersion}/` + (source ? `?source=${source}` : ''));
        setStateAtStep({ step: 1, complete: false, ignore: false });
        setActiveStep({ activeStep: 1 });
      },
      onComplete: (quoteVersion) => {
        return navigate(`/get-quote-${quoteVersion}/` + (source ? `?source=${source}` : ''));
      },
    });
    setStateAtStep({ step: 0, complete: true });

    // Amplitude
    const digitalAnalyticsProps = {
      userProperties: [
        { name: CHANNEL, value: CHANNEL_NAME },
        { name: LEAD_SOURCE, value: source ?? leadSourceType },
      ],
      event: {
        name: QUOTE_STARTED,
        properties: [
          { name: QUOTE_VERSION, value: quoteVersion },
          { name: CHANNEL, value: CHANNEL_NAME }
        ],
      },
    };
    sync(digitalAnalyticsProps);
  };

  initialFieldState = {
    zip: {
      value: this.getInitialZipFieldState(),
      required: !this.props.stepAccessible,
    },
  };

  getInitialZipFieldState() {
    const { location } = this.props;
    const params = queryString.parse(location?.search);
    return params.zip || this.props.zip;
  }

  /**
   * This is implemented as an imediately-invoked function so the
   * value doesn't change on re-renders.
   */
  ctaButtonText = (() => {
    let result = 'Check our prices'; // control
    if (CONTROL_VARIANT !== useVariant('hb-enter-zip-cta-button-text')) {
      // this is an A/A test so it is the same.
      result = 'Check our prices';
    }
    return result;
  })();

  render() {
    const { blockedDisplay, isAgent, token } = this.props;

    return (
      <Fragment>
        <StyledForm
          initialFieldState={this.initialFieldState}
          onSubmit={this.routeToQuote}
          blockedDisplay={blockedDisplay}
        >
          {!isAgent && (
            <Form.Field name='zip'>
              {(props) => (
                <StyledZipField
                  blockedDisplay={blockedDisplay}
                  inputmode='numeric'
                  {...props}
                  showPlaceholder={true}
                  placeholder='Enter your Zip Code'
                />
              )}
            </Form.Field>
          )}
          <Form.Actions
            render={() => (
              <StyledBtn type='submit' appearance='primary' blockedDisplay={blockedDisplay} disabled={!token}>
                {this.ctaButtonText}
              </StyledBtn>
            )}
          />
        </StyledForm>
      </Fragment>
    );
  }
}

CtaForm.propTypes = {
  productId: PropTypes.string,
  requestProperties: PropTypes.func.isRequired,
  setStateAtStep: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  setZip: PropTypes.func.isRequired,
  blockedDisplay: PropTypes.bool, //For displaying Zip field and cta button in block level in both desktop and mobile. Don't apply this for displaying inline
  isAgent: PropTypes.bool,
  token: PropTypes.string,
  property: PropTypes.string,
  properties: PropTypes.object,
};

CtaForm.defaultProps = {
  blockedDisplay: false,
};

const mapStateToProps = ({
  getQuote: { zip, currentStepError, stepAccessible, property, leadSourceType },
  user: { isAgent, token },
  properties,
}) => {
  return {
    zip,
    currentStepError,
    stepAccessible,
    isAgent,
    token,
    property,
    properties,
    leadSourceType,
  };
};
export default connect(mapStateToProps, {
  requestProperties,
  setZip,
  setStateAtStep,
  setActiveStep,
  setLeadSourceType,
})(CtaForm);
